import React, { useState, useEffect } from 'react'
import './StatusText.css';
import * as signalR from "@microsoft/signalr";


function StatusText({drone, showMsgs, startMsgs}){
    const protocol = new signalR.JsonHubProtocol();
    const [hub, setHub] = useState(hubConnect);
    const [imei, setImei] = useState(drone?.imei ?? null);
    const [statusText, setStatusText] = useState([]);

    useEffect(() => {
        console.log("StatusText mount");
      }, []);

    useEffect(() => {
        return () => {
            hub.stop();
        };
    }, []);

    useEffect(() => {
        if(drone != null) {
            setImei(drone.imei);
        }
        //todo: request api
    }, [drone]);

    useEffect(() => {
        setStatusText(startMsgs);
        //setStatusText([{imei:'1455260271213448482', message:'Message 2 test', severity:1, time:'11:22:30'}]);
    }, [startMsgs]);

    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;

        connection.on('StatusText', (message) =>
        {
            setStatusText((prevText) => {
                // Фильтруем, оставляя только элементы с другим imei + 20 последних для этого imei
                const filtered = prevText.filter((msg) => msg.imei !== message.imei);
                const sameImei = prevText.filter((msg) => msg.imei === message.imei);
            
                return [...filtered, ...sameImei.slice(-19), message]; // Оставляем только 20 последних
              });
        });
        connection.start();
        return connection;
    }

    function Messages() {
        return (
            <>
                {statusText.filter(x => x.imei === imei).toReversed().map(x => <Message text={x.message} time={x.time} severity={x.severity}/>)}
            </>
        )
    }

    function Message({text, time, severity}) {
        return (
            <div className='message'>
                <div className='message-time'>{time}</div>
                <div className={'message-text ' + getClassColor(severity)} >{text}</div>
            </div>
        )
    }

    function getClassColor(severity){
        if(severity === null)
            return 'addition-white'

        if(severity <= 2)
            return 'addition-red'

        if(severity <= 4)
            return 'addition-yell'
    }

    return(
        <>
            {drone == null ? <></> : 
                <div className='status-text'>
                    {showMsgs ? <Messages /> : <></>}
                </div>
            }
        </>
        
        
    )
}

export default StatusText;